module.exports = __webpack_public_path__ + "static/media/no_results_undraw.20c64fa0.svg";